import { Component, OnInit, HostListener } from '@angular/core';
import { ResidentialService } from '../residential.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {

  constructor(private residentialService: ResidentialService, private router: Router) { }
  // To handle the page close or reload event
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
      event.returnValue = false;
      setTimeout(() => {
        return this.router.navigateByUrl('/skippage');
      }, 50);
  }
  ngOnInit() {
  }

}
